/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */

import React, {Component} from 'react';
import './viewCourses.scss';
import Slider from "react-slick";
import {Card, CardBody, Row, Col} from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './viewCourses.scss'
import {Button} from "reactstrap";
import * as constants from "../../const/constants";
import * as courseService from '../../services/courses'
import {lang, language} from "../../const/language";
import {getSliderSetting} from "../../utils/commonFunc";
import * as commonFun from '../../utils/commonFunc'
import moment from "moment";
import GetPaymentModel from '../../components/Modals/payeMentDetailsCourse/getPaymentModel'
import toastr from "toastr";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import i from "react-icofont";


class viewCourses extends Component {
    state = {
        viewModel: false,
        courseId: '',
        course: [],
        courses: []
    };

    async componentDidMount() {
        await courseService.getInstituteCourses().then(
            res => {
                if (res.success) {
                    this.setState({
                        courses: res.body
                    });
                }

            }
        );


    }

    firstJoinCourse = async (course) => {
        if (this.props.userType !== 1) {
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`,
                // state: this.props.state.id
            })
        } else {

            await this.setState({course: course});
            await this.setState({courseId: course.courseId});
            await this.setState({viewModel: true});
        }

    };

    JoinToClass = (course) => {


        if (this.props.userType !== 1) {

            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`,
                // state: this.props.state.id
            })
        } else {
            let obj={
                id:course.courseId,
                name:course.name
            };
            commonFun.joinCourseHandler(this.props,obj).then(res=>{
            })

        }
    };

    // JoinToClass = (course) => {
    //     let obj={
    //         id:course.courseId,
    //         name:course.name
    //     };
    //     console.log(this.props);
    //     commonFunc.joinCourseHandler(this.props, obj).then(r => {
    //         console.log(r)
    //     })
    // };


    viewCourse = (courseId, courseDTO) => {
        let courseProps = {
            courseId: courseId,
            courseDetails: courseDTO,
            userType: this.props.userType
        };

        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
            state: courseProps
        })
    };
    viewModel = () => {
        this.setState({viewModel: false})
    };


    render() {


        let {courses} = this.state.courses;
        let settings = getSliderSetting(this.state.courses);
        console.log(this.state.courses);
        return (
            <div>
                {this.state.viewModel ?
                    <GetPaymentModel history={this.props.history} courseId={this.state.courseId}
                                     courseDetails={this.state.course} closeModal={this.viewModel}
                                     userType={this.props.userType}/> : null}
                <div className="viewCourse-list">
                    <div className='container teachers-slide-show'>
                        <Slider {...settings}>

                            {
                                this.state.courses.map((course, index) => (
                                    <>
                                        {course.status === "ACTIVE" ?
                                            <Card key={(index + course.name).toString()} className="courseCard"
                                            >
                                                <CardBody style={{padding: 0}}>
                                                    <div align='center'>
                                                        <img src={course.imageUrl} alt={"."}
                                                             className={"blur-img"}
                                                             />
                                                        <img src={course.imageUrl} alt={"."}
                                                             className={"slideshow-pro-image shadow"}
                                                            />
                                                    </div>

                                                    <div style={{cursor: 'pointer'}}
                                                         onClick={() => {
                                                             let courseDTO = course;
                                                             this.viewCourse(course.courseId, courseDTO)
                                                         }}
                                                    >
                                                        <p className='topic'>{course.name}</p>

                                                        {course.coursesDayTimes.length != 0 ?
                                                            <div className='timeTable'>පන්ති කාලසටහන
                                                                {course.coursesDayTimes.map((dateRow, index) => (
                                                                    <ul key={index}>
                                                                        <li>{dateRow.day === 'MONDAY' ? 'සඳුදා' :
                                                                            dateRow.day === 'TUESDAY' ? 'අඟහරුවාදා' :
                                                                                dateRow.day === 'WEDNESDAY' ? 'බදාදා' :
                                                                                    dateRow.day === 'THURSDAY' ? 'බ්‍රහස්පතින්දා' :
                                                                                        dateRow.day === 'FRIDAY' ? 'සිකුරාදා' :
                                                                                            dateRow.day === 'SATURDAY' ? 'සෙනසුරාදා' :
                                                                                                'ඉරිදා'

                                                                        } -{` `}
                                                                            {moment(`2000-01-01 ${dateRow.startTime}`).format('h:mm a ')}
                                                                            to {moment(`2000-01-01 ${dateRow.endTime}`).format('h:mm a ')} </li>
                                                                    </ul>
                                                                ))}
                                                            </div> : null}

                                                        {course.noOfInstallments != 1 ?
                                                            <p style={{marginLeft: '5%'}}>

                                                                ගෙවීම් {course.noOfInstallments} කින් සිදුකල හැක.
                                                            </p> :
                                                            <p style={{marginLeft: '5%'}}>
                                                                එකවර ගෙවීම සිදුකලයුතුය.
                                                            </p>}

                                                        {
                                                            moment(course.nextDayOfCourseSession).format('YYYY-MM-DD') < moment(course.startDate).format('YYYY-MM-DD') ?
                                                                <p style={{marginLeft: '5%'}}>ආරම්භක දිනය :
                                                                    {course.startDate}</p>
                                                                : null
                                                        }
                                                        {course.nextDayOfCourseSession !== null?
                                                            <p style={{color: "red", marginLeft: '5%'}}>
                                                                මීළගට පන්ති
                                                                පැවැත්වෙන දිනය :{` `}
                                                                {moment(course.nextDayOfCourseSession).format('YYYY-MM-DD')}
                                                            </p> :null}
                                                    </div>

                                                    <div className="pb-3">
                                                        <div style={{zIndex: 100}} className={"vc-action mt-3"}>
                                                            {course.buttonStatus === 'BOUGHT' ?
                                                                <Button
                                                                    className="com-btn reg-btn normal-txt mb-1 btn "
                                                                    color="default" onClick={() => {
                                                                    this.JoinToClass(course)
                                                                }}>
                                                                    {language[lang].JoinTheClass}
                                                                </Button> :
                                                                course.buttonStatus === 'PENDING' ?
                                                                    <Button
                                                                        className="com-btn pending-btn mt-3  mb-1 btn">
                                                                        {`${language[lang].PaymentPending}`}
                                                                        {/*for ${moment(new Date()).format("MMM")}*/}
                                                                    </Button>
                                                                    : course.buttonStatus === 'BUY' ?
                                                                    <Button
                                                                        className="com-btn log-btn normal-txt mb-1"
                                                                        color="default" onClick={() => {
                                                                        this.firstJoinCourse(course)
                                                                    }}>
                                                                        {language[lang].registerForCourse}
                                                                    </Button> : null
                                                            }

                                                            <Button className="com-btn log-btn normal-txt mb-1"
                                                                    color="red" onClick={() => {
                                                                let courseDTO = course;
                                                                this.viewCourse(course.courseId, courseDTO)
                                                            }}>
                                                                {language[lang].viewCourseDetails}
                                                            </Button>

                                                            {/*<Button className="com-btn log-btn normal-txt mb-1"*/}
                                                            {/*        color="default">*/}
                                                            {/*    Pay Installment*/}
                                                            {/*</Button>*/}
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> : null}
                                    </>
                                ))}

                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
}
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect('', mapDispatchToProps)(withRouter(viewCourses));

// export default viewCourses;
